{
  "status": {
    "pending": "待出",
    "preliminary": "初步报告",
    "final": "终报",
    "corrected": "更正",
    "amended": "补充",
    "addended": "已有补充",
    "enteredInError": "录入错误",
    "unknown": "未知"
  },
  "review": {
    "title": "结果审阅",
    "printLabel": "打印结果",
    "summary": {
      "count_one": "{{count}} 条结果",
      "count_other": "{{count}} 条结果",
      "criticalUnacknowledged": "{{count}} 条危急值未确认"
    },
    "view": {
      "timeline": "时间轴",
      "flowsheet": "流水表"
    },
    "filter": {
      "date": "日期",
      "type": "类型",
      "status": "状态",
      "statusAll": "全部"
    },
    "dateRange": {
      "h24": "近 24 小时",
      "h48": "近 48 小时",
      "d7": "近 7 天",
      "d30": "近 30 天",
      "all": "全部"
    },
    "resultType": {
      "all": "全部",
      "lab": "检验",
      "imaging": "影像",
      "pathology": "病理",
      "cardiology": "心电",
      "microbiology": "微生物"
    },
    "criticalOnlyToggle": "仅显示危急值",
    "criticalBadge": "危急",
    "actions": {
      "acknowledgeCritical": "确认危急值",
      "acknowledgeAllCritical": "确认全部危急结果 ({{count}})"
    },
    "detail": {
      "resultNumber": "结果编号",
      "performingProviderId": "执行医师编号",
      "verifiedByProviderId": "审核医师编号",
      "verifiedAt": "审核时间",
      "specimenCollected": "标本采集时间",
      "clinicalSignificance": "临床意义",
      "recommendations": "建议",
      "report": "报告",
      "addendum": "补充报告",
      "criticalAcknowledged": "危急值已确认",
      "providerHash": "医师 #{{id}}",
      "acknowledgedAt": " 时间 {{when}}",
      "specimenType": "标本类型",
      "grossDescription": "大体描述",
      "microscopicDescription": "镜下描述",
      "accessionNumber": "检查号",
      "bodyRegion": "检查部位",
      "studyInstanceUid": "检查实例 UID",
      "cardiologyMeasurements": "测量值",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "正在加载结果…",
    "loadError": "加载结果失败,请重试。",
    "empty": "未找到符合所选筛选条件的结果。",
    "toast": {
      "acknowledgeSuccess": "危急值已确认",
      "acknowledgeError": "确认结果失败"
    },
    "susceptibility": {
      "title": "病原体与药敏",
      "antibiotic": "抗菌药物",
      "interpretation": "判读",
      "mic": "MIC",
      "unnamedOrganism": "未命名病原体",
      "noPanel": "该病原体未报告药敏结果。"
    },
    "components": {
      "value": "结果值",
      "referenceRange": "参考范围"
    }
  },
  "pending": {
    "title": "待出结果",
    "countBadge_one": "{{count}} 条待出",
    "countBadge_other": "{{count}} 条待出",
    "autoRefresh": "自动刷新 {{seconds}} 秒",
    "updated": "更新于 {{when}}",
    "searchPlaceholder": "按患者姓名、MRN 或医嘱搜索…",
    "filtersButton": "筛选",
    "fields": {
      "orderType": "医嘱类型",
      "allTypes": "全部类型",
      "priority": "优先级",
      "allPriorities": "全部优先级",
      "dateFrom": "起始日期",
      "dateTo": "截止日期"
    },
    "orderType": {
      "lab": "检验",
      "imaging": "影像",
      "procedure": "操作",
      "consultation": "会诊",
      "laboratory": "检验",
      "radiology": "放射",
      "surgery": "手术",
      "therapy": "治疗",
      "medication": "用药",
      "admission": "入院"
    },
    "aria": {
      "dateFrom": "待出结果起始日期",
      "dateTo": "待出结果截止日期"
    },
    "columns": {
      "patient": "患者",
      "mrn": "MRN",
      "order": "医嘱",
      "type": "类型",
      "orderedBy": "开嘱医师",
      "ordered": "开嘱时间",
      "expected": "预计时间",
      "priority": "优先级"
    },
    "loading": "正在加载待出结果…",
    "loadError": "加载待出结果失败",
    "retry": "重试",
    "empty": "未找到待出结果。",
    "awaitingResult": "等待结果",
    "specimenReceived": "标本已接收",
    "inLab": "实验室处理中",
    "cancelledByLab": "实验室已取消",
    "overdue": "已逾期",
    "expectedBy": "预计 {{date}} 前出"
  },
  "critical": {
    "title": "危急值结果",
    "autoRefresh": "自动刷新 {{seconds}} 秒",
    "updated": "更新于 {{when}}",
    "unacknowledgedHeading_one": "{{count}} 条危急值未确认",
    "unacknowledgedHeading_other": "{{count}} 条危急值未确认",
    "escalationBanner": "上述结果需医师立即确认。",
    "acknowledgeWithinMinutes": "请在 {{minutes}} 分钟内确认",
    "routeBackToProvider": "转回开嘱医师",
    "attendingSignoff": "需主治医师签字",
    "searchPlaceholder": "按患者或检查名称搜索…",
    "showAcknowledgedToggle": "显示已确认",
    "escalationTime": "T+{{minutes}} 分",
    "criticalFallback": "危急",
    "loading": "正在加载危急值结果…",
    "loadError": "加载危急值结果失败",
    "empty": "无待确认的危急值结果。",
    "detailToggleLabel": "显示结果详情",
    "openFullChart": "打开完整病历",
    "columns": {
      "patient": "患者",
      "mrn": "MRN",
      "test": "检查项目",
      "value": "数值",
      "impression": "印象",
      "resultTime": "结果时间",
      "escalation": "升级时长",
      "acknowledged": "已确认",
      "actions": "操作"
    },
    "actions": {
      "acknowledge": "确认"
    },
    "toast": {
      "acknowledgeSuccess": "危急值已确认",
      "acknowledgeError": "确认结果失败"
    },
    "refreshFailed": "无法刷新——显示的是{{when}}的危急值结果。",
    "incomplete": "仅显示 {{total}} 项危急值结果中的 {{shown}} 项。此列表不完整。"
  },
  "acknowledged": {
    "pending": "等待确认",
    "acknowledged": "已确认",
    "escalated": "已升级",
    "expired": "确认窗口已过期"
  },
  "flowsheet": {
    "analyte": "检验项目",
    "empty": "暂无可趋势分析的检验项目",
    "emptyHint": "影像、病理与微生物报告显示在时间线视图中。",
    "trend": {
      "toggle": "{{analyte}} 趋势图",
      "referenceRange": "参考值 {{range}}",
      "nonNumericOmitted_one": "{{count}} 项文本结果未绘制",
      "nonNumericOmitted_other": "{{count}} 项文本结果未绘制"
    }
  }
}
